import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy for SMS Textr</h1>
      <p><strong>Effective Date:</strong> 1st November, 2024.</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to SMS Textr! Your privacy is important to us. This Privacy Policy explains how SMS Textr collects, uses, and protects your information when you use our services.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>Personal Information</h3>
      <p>
        We collect certain personal information when you create an account, such as:
      </p>
      <ul>
        <li><strong>Name:</strong> Used for account creation and personalization.</li>
        <li><strong>Email Address:</strong> For account login, notifications, and communication.</li>
        <li><strong>Phone Number:</strong> To facilitate SMS functionality.</li>
      </ul>
      
      <h3>Usage Information</h3>
      <p>
        We collect data about how you use our services, including:
      </p>
      <ul>
        <li><strong>SMS History:</strong> SMS messages sent via our service, including recipient number, date, and message details.</li>
        <li><strong>Billing History:</strong> SMS Credits purchased Date and time, amount and number of credits.</li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information collected to:</p>
      <ul>
        <li>Provide and improve our SMS services.</li>
        <li>Respond to your requests and communicate updates.</li>
        <li>Ensure the security of your account and data.</li>
      </ul>

      <h2>4. How We Share Your Information</h2>
      <p>We do not sell or share your personal information with third parties except:</p>
      <ul>
        <li><strong>With Service Providers:</strong> Trusted third-party services (e.g., Stripe) necessary to operate SMS Textr. These providers are bound by confidentiality agreements.</li>
      </ul>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. The effective date will be updated to reflect the latest changes. Please review this policy regularly.
      </p>

      <h2>9. Contact Us</h2>
      <p>If you have questions about this Privacy Policy, please contact us at:</p>
      <ul>
        <li><strong>Email:</strong> <a href="mailto:smstextr@gmail.com">smstextr@gmail.com</a></li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
